import React, { useState, useRef, useEffect } from 'react';
import ReactQuill from 'react-quill';
import EditorTexto from './Input/EditorTexto';
import TagGroup from './Form/TagGroup.js';
import './contentblock.css';

const BlockEditorInformation = () => {
  // Estados
  const [menuBlocks, setMenuBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [draggedBlock, setDraggedBlock] = useState(null);
  const [editingBlock, setEditingBlock] = useState(null);
  
  // Estados para el modal de edición de imagen
  const [editingTab, setEditingTab] = useState('basic');
  const [editingImage, setEditingImage] = useState(null); // { blockIndex, imageId, imageData }
  const [showImageModal, setShowImageModal] = useState(false);

  const today = new Date();

  const fechaActual = today.toLocaleDateString('en-CA', {
    timeZone: 'America/Lima',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });

const unAnio = new Date(today);
unAnio.setFullYear(unAnio.getFullYear() + 1);

const fechaExpirationDefault = unAnio.toLocaleDateString('en-CA', {
  timeZone: 'America/Lima',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
});



  console.log(menuBlocks,editingImage)


const quillModules = {
  toolbar: [
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    [{ 'font': [] }],
    [{ 'size': ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ 'color': [] }, { 'background': [] }],
    [{ 'script': 'sub' }, { 'script': 'super' }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
    [{ 'indent': '-1' }, { 'indent': '+1' }],
    [{ 'align': [] }],
    ['blockquote', 'code-block'],
    ['link', 'image', 'video'],
    ['clean'] // Botón para limpiar formato
  ],
  clipboard: {
    matchVisual: false
  }
};

const quillFormats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike',
  'color', 'background',
  'script', 'sub', 'super',
  'list', 'bullet', 'indent',
  'align',
  'blockquote', 'code-block',
  'link', 'image', 'video'
];



// Función para abrir modal de edición - asegurar que typeview existe
const openImageEditModal = (blockIndex, imageId, imageData) => {
  // Asegurar que typeview existe en los datos
  const imageDataWithDefaults = {
    ...imageData,
    typeview: imageData.typeview || 'web' // Valor por defecto
  };
  
  setEditingImage({
    blockIndex,
    imageId,
    data: { ...imageDataWithDefaults } // Copia para editar
  });
  setShowImageModal(true);
};


// ============================================
// FUNCIONES PARA MANEJO DE IMÁGENES
// ============================================

/**
 * Sube múltiples imágenes y las procesa con metadatos
 */
const handleGalleryUpload = (e, blockIndex) => {
  const files = Array.from(e.target.files);
  if (files.length === 0) return;

  // Validar cada archivo
  const validFiles = files.filter(file => {
    if (!file.type.startsWith('image/')) {
      alert(`"${file.name}" no es una imagen válida`);
      return false;
    }
    if (file.size > 5 * 1024 * 1024) {
      alert(`"${file.name}" excede los 5MB`);
      return false;
    }
    return true;
  });

  if (validFiles.length === 0) return;

  // Procesar cada imagen con metadatos
  const processImages = validFiles.map(file => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        // Extraer nombre sin extensión para el título por defecto
        const fileName = file.name.split('.')[0];
        
        resolve({
          id: `img-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
          url: event.target.result,
          file: file,
          name: file.name,
          // Metadatos por imagen
          metaTitle: fileName, // Título SEO por defecto
          alt: fileName, // Texto alternativo
          caption: '',
          link: {
            url: '',
            target: '_blank',
            rel: 'noopener noreferrer'
          },
          seo: {
            title: fileName,
            description: '',
            keywords: ''
          },
          // Metadatos adicionales
          width: null,
          height: null,
          size: file.size,
          type: file.type,
          createdAt: new Date().toISOString()
        });
      };
      reader.readAsDataURL(file);
    });
  });

  Promise.all(processImages).then(newImages => {
    setMenuBlocks(prev => {
      const newBlocks = [...prev];
      if (!newBlocks[blockIndex].data.images) {
        newBlocks[blockIndex].data.images = [];
      }
      newBlocks[blockIndex].data.images = [...newBlocks[blockIndex].data.images, ...newImages];
      return newBlocks;
    });
    
    //showNotification(`${newImages.length} imagen(es) añadida(s) correctamente`);
  });
};

/**
 * Elimina una imagen específica de la galería
 */
const removeGalleryImage = (blockIndex, imageId) => {
  if (!window.confirm('¿Eliminar esta imagen de la galería?')) return;
  
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    
    if (imageIndex !== -1) {
      // Liberar URL objeto si existe
      if (newBlocks[blockIndex].data.images[imageIndex].url?.startsWith('blob:')) {
        URL.revokeObjectURL(newBlocks[blockIndex].data.images[imageIndex].url);
      }
      
      newBlocks[blockIndex].data.images = newBlocks[blockIndex].data.images.filter(
        img => img.id !== imageId
      );
    }
    return newBlocks;
  });
  
  //showNotification('Imagen eliminada');
};

/**
 * Reordena las imágenes de la galería (drag & drop)
 */
const reorderGalleryImages = (blockIndex, sourceIndex, targetIndex) => {
  if (sourceIndex === targetIndex) return;
  
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const images = [...newBlocks[blockIndex].data.images];
    const [movedImage] = images.splice(sourceIndex, 1);
    images.splice(targetIndex, 0, movedImage);
    newBlocks[blockIndex].data.images = images;
    return newBlocks;
  });
  
  //showNotification('Imagen reordenada');
};

/**
 * Actualiza el meta title de una imagen
 */
const updateImageMetaTitle = (blockIndex, imageId, metaTitle) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      newBlocks[blockIndex].data.images[imageIndex].metaTitle = metaTitle;
      // También actualizar SEO title
      if (!newBlocks[blockIndex].data.images[imageIndex].seo) {
        newBlocks[blockIndex].data.images[imageIndex].seo = {};
      }
      newBlocks[blockIndex].data.images[imageIndex].seo.title = metaTitle;
    }
    return newBlocks;
  });
};

const updateDatePublish = (blockIndex, imageId, metaTitle) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      newBlocks[blockIndex].data.images[imageIndex].datepublish = metaTitle;
      
      if (!newBlocks[blockIndex].data.images[imageIndex].datepublish) {
        newBlocks[blockIndex].data.images[imageIndex].datepublish = "";
      }
      newBlocks[blockIndex].data.images[imageIndex].datepublish = metaTitle;
    }
    return newBlocks;
  });
};

const updateDateExpiration = (blockIndex, imageId, metaTitle) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      newBlocks[blockIndex].data.images[imageIndex].dateexpiration = metaTitle;
      // También actualizar SEO title
      if (!newBlocks[blockIndex].data.images[imageIndex].dateexpiration) {
        newBlocks[blockIndex].data.images[imageIndex].dateexpiration = "";
      }
      newBlocks[blockIndex].data.images[imageIndex].dateexpiration = metaTitle;
    }
    return newBlocks;
  });
};

/**
 * Actualiza el texto alternativo (alt) de una imagen
 */
const updateImageAlt = (blockIndex, imageId, alt) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      newBlocks[blockIndex].data.images[imageIndex].alt = alt;
    }
    return newBlocks;
  });
};

/**
 * Actualiza el pie de foto de una imagen
 */
const updateImageCaption = (blockIndex, imageId, caption) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      newBlocks[blockIndex].data.images[imageIndex].caption = caption;
    }
    return newBlocks;
  });
};

/**
 * Actualiza el link de una imagen
 */
const updateImageLink = (blockIndex, imageId, linkData) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      newBlocks[blockIndex].data.images[imageIndex].link = {
        ...newBlocks[blockIndex].data.images[imageIndex].link,
        ...linkData
      };
    }
    return newBlocks;
  });
};

/**
 * Actualiza la descripción SEO de una imagen
 */
const updateImageSeoDescription = (blockIndex, imageId, description) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      if (!newBlocks[blockIndex].data.images[imageIndex].seo) {
        newBlocks[blockIndex].data.images[imageIndex].seo = {};
      }
      newBlocks[blockIndex].data.images[imageIndex].seo.description = description;
    }
    return newBlocks;
  });
};

/**
 * Actualiza las keywords SEO de una imagen
 */
const updateImageSeoKeywords = (blockIndex, imageId, keywords) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      if (!newBlocks[blockIndex].data.images[imageIndex].seo) {
        newBlocks[blockIndex].data.images[imageIndex].seo = {};
      }
      newBlocks[blockIndex].data.images[imageIndex].seo.keywords = keywords;
    }
    return newBlocks;
  });
};

const updateImageTypeView = (blockIndex, imageId, typeview) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const block = newBlocks[blockIndex];
    
    if (block && block.data && block.data.images) {
      const imageIndex = block.data.images.findIndex(img => img.id === imageId);
      if (imageIndex !== -1) {
        // Crear una copia profunda para evitar mutaciones
        newBlocks[blockIndex] = {
          ...block,
          data: {
            ...block.data,
            images: [
              ...block.data.images.slice(0, imageIndex),
              {
                ...block.data.images[imageIndex],
                typeview: typeview
              },
              ...block.data.images.slice(imageIndex + 1)
            ]
          }
        };
      }
    }
    return newBlocks;
  });
};
/**
 * Actualiza el target de los links (global para la galería)
 */
const updateGalleryLinkTarget = (blockIndex, openInNewTab) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    newBlocks[blockIndex].data.openLinksInNewTab = openInNewTab;
    
    // Actualizar todas las imágenes
    if (newBlocks[blockIndex].data.images) {
      newBlocks[blockIndex].data.images = newBlocks[blockIndex].data.images.map(img => ({
        ...img,
        link: {
          ...img.link,
          target: openInNewTab ? '_blank' : '_self'
        }
      }));
    }
    return newBlocks;
  });
};

/**
 * Duplica una imagen (crea una copia)
 */
const duplicateGalleryImage = (blockIndex, imageId) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    const imageIndex = newBlocks[blockIndex].data.images.findIndex(img => img.id === imageId);
    
    if (imageIndex !== -1) {
      const originalImage = newBlocks[blockIndex].data.images[imageIndex];
      const duplicatedImage = {
        ...originalImage,
        id: `img-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        name: `Copia de ${originalImage.name}`,
        metaTitle: `${originalImage.metaTitle} (copia)`
      };
      
      newBlocks[blockIndex].data.images.splice(imageIndex + 1, 0, duplicatedImage);
    }
    return newBlocks;
  });
  
  //showNotification('Imagen duplicada');
};

/**
 * Exporta los metadatos de la galería a JSON
 */
const exportGalleryMetadata = (blockIndex) => {
  const block = menuBlocks[blockIndex];
  const metadata = {
    gallery: {
      columns: block.data.columns,
      gap: block.data.gap,
      aspectRatio: block.data.aspectRatio,
      lightbox: block.data.lightbox,
      showCaptions: block.data.showCaptions
    },
    images: block.data.images.map(img => ({
      id: img.id,
      name: img.name,
      metaTitle: img.metaTitle,
      alt: img.alt,
      caption: img.caption,
      link: img.link,
      seo: img.seo,
      size: img.size,
      type: img.type
    }))
  };
  
  const dataStr = JSON.stringify(metadata, null, 2);
  const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
  
  const exportFileDefaultName = `galeria-metadata-${Date.now()}.json`;
  
  const linkElement = document.createElement('a');
  linkElement.setAttribute('href', dataUri);
  linkElement.setAttribute('download', exportFileDefaultName);
  linkElement.click();
  
  //showNotification('Metadatos exportados');
};

/**
 * Limpia todas las imágenes de la galería
 */
const clearAllGalleryImages = (blockIndex) => {
  if (!window.confirm('¿Eliminar TODAS las imágenes de la galería?')) return;
  
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    // Liberar URLs objeto
    if (newBlocks[blockIndex].data.images) {
      newBlocks[blockIndex].data.images.forEach(img => {
        if (img.url?.startsWith('blob:')) {
          URL.revokeObjectURL(img.url);
        }
      });
    }
    newBlocks[blockIndex].data.images = [];
    return newBlocks;
  });
  
  //showNotification('Galería vaciada');
};

/**
 * Actualiza todas las imágenes con un meta title por defecto
 */
const updateAllMetaTitles = (blockIndex, defaultTitle) => {
  setMenuBlocks(prev => {
    const newBlocks = [...prev];
    if (newBlocks[blockIndex].data.images) {
      newBlocks[blockIndex].data.images = newBlocks[blockIndex].data.images.map((img, idx) => ({
        ...img,
        metaTitle: defaultTitle.replace('{n}', idx + 1)
      }));
    }
    return newBlocks;
  });
  
  //showNotification('Meta titles actualizados');
};








  

  const uploadApiImageService = async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    const res = await fetch(window.path_service_website+"/aux/api/file", {
      method: "POST",
      body: formData
    });

    const data = await res.json();

    // respuesta esperada:
    // { url: "https://cdn.miapp.com/images/abc.png" }

    return data.url;
  };


  const processImagesTree = async (items) => {
    const newItems = [];

    for (const item of items) {
      let newItem = { ...item };

      // 🔥 Si tiene imagen local
      //console.log(newItem.imageFile,item)
      if (newItem.imageFile instanceof File) {
        const url = await uploadApiImageService(newItem.imageFile);

        newItem.imageFile = url;      // ahora es string
        newItem.imagePreview = url;   // preview remoto
        newItem.imageName = newItem.imageName || newItem.imageFile.name;
      }

      if (
          ["advanced-gallery","banner-gallery"].includes(newItem.type)
      ){

          if (Array.isArray(newItem.data.images)) {
            
            const newItemsGallery = [];

            for (const itemimg of newItem.data.images) {
            
            let dataImage = { ...itemimg };
            console.log(dataImage, (dataImage.file instanceof File)   );
              
              if (dataImage.file instanceof File) {
                const urlGallery = await uploadApiImageService(dataImage.file);
                dataImage.file = urlGallery;   // ahora string
                dataImage.url = urlGallery;    // preview remoto

                newItemsGallery.push(dataImage);
              }else{
                newItemsGallery.push(dataImage);
              }

            }
            

            newItem.data.images = newItemsGallery;

          }

      }


      // ⬇️ Procesar hijos recursivamente
      
      /*
       //no debe estar disponible
      if (newItem.children?.length) {
        newItem.children = await processImagesTree(newItem.children);
      }
      */

      newItems.push(newItem);
    }

    return newItems;
  };  


  const getApiDataCategory = async () => {
    const response = await fetch(window.path_service_website+"/categoria/list/menu_minimal",{method:'POST'})    
    const data = await response.json()

      try {
        window.Listcategory = data.data
      } catch (e) {
        console.error("Error cargando menú:", e);
      }

  };

  const getApiDataTransversal = async () => {
    const response = await fetch(window.path_service_website+"/api/page/list/transversal_minimal",{method:'POST'})    
    const data = await response.json()

      try {
        window.Listtransversal = data.data
      } catch (e) {
        console.error("Error cargando menú:", e);
      }

  };

  const getApiDataInitial = async () => {
    const response = await fetch(window.path_service_website+"/aux/api/list/pages",{method:'POST',body:  JSON.stringify({id_comercio: 4 , vista: "legales"}) })
    const data = await response.json()

      try {
        setMenuBlocks(data.data.data_raw);
      } catch (e) {
        console.error("Error cargando menú:", e);
      }

  };

  useEffect(() => {
    getApiDataCategory();
    getApiDataTransversal();
    getApiDataInitial();

  }, []);

  const handleImageUpload = (e, itemId) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validar que sea una imagen
    if (!file.type.startsWith('image/')) {
      alert('Por favor selecciona un archivo de imagen válido');
      return;
    }

    // Validar tamaño (opcional - 5MB máximo)
    if (file.size > 5 * 1024 * 1024) {
      alert('La imagen no debe superar los 5MB');
      return;
    }

    // Crear preview URL
    const previewUrl = URL.createObjectURL(file);


    // Actualizar el item con la imagen
    const updateItems = (items) => {
      return items.map(item => {
        if (item.id === itemId) {
          return {
            ...item,
            imageFile: file,
            imagePreview: previewUrl,
            imageName: file.name
          };
        }
        if (item.children && item.children.length > 0) {
          return { ...item, children: updateItems(item.children) };
        }
        return item;
      });
    };

    setMenuBlocks(updateItems(menuBlocks));
    //showNotification('Imagen añadida al elemento');
  };

  const removeImage = (itemId) => {
    const updateItems = (items) => {
      return items.map(item => {
        if (item.id === itemId) {
          // Limpiar la URL del objeto para evitar memory leaks
          if (item.imagePreview) {
            URL.revokeObjectURL(item.imagePreview);
          }
          const { imageFile, imagePreview, imageName, ...rest } = item;
          return rest;
        }
        if (item.children && item.children.length > 0) {
          return { ...item, children: updateItems(item.children) };
        }
        return item;
      });
    };

    setMenuBlocks(updateItems(menuBlocks));
    //showNotification('Imagen eliminada');
  };  


  // Elementos disponibles (panel derecho)
  const availableBlocks = [
    // Bloques de texto
    { 
      id: 'block-heading', 
      title: 'Título', 
      type: 'heading', 
      icon: '🔠',
      category: 'Texto',
      description: 'Encabezado de sección',
      defaultData: { 
        level: 'h2', 
        align: 'left',
        color: '#000000',
        fontSize: '24px'
      }
    },
    { 
      id: 'block-subheading', 
      title: 'Subtítulo', 
      type: 'subheading', 
      icon: '🔡',
      category: 'Texto',
      description: 'Texto secundario',
      defaultData: { 
        level: 'h3', 
        align: 'left',
        color: '#666666',
        fontSize: '18px'
      }
    },
    { 
      id: 'block-paragraph', 
      title: 'Párrafo', 
      type: 'paragraph', 
      icon: '📝',
      category: 'Texto',
      description: 'Texto descriptivo',
      defaultData: { 
        content: 'Texto del párrafo...',
        align: 'left',
        color: '#333333'
      }
    },
    
    // Bloques de imagen
    { 
      id: 'block-image', 
      title: 'Imagen simple', 
      type: 'image', 
      icon: '🖼️',
      category: 'Imagen',
      description: 'Una sola imagen',
      defaultData: { 
        url: '',
        alt: '',
        width: '100%',
        height: 'auto',
        borderRadius: '0',
        caption: ''
      }
    },
    /*
    // Bloques de separadores
    { 
      id: 'block-separator', 
      title: 'Separador simple', 
      type: 'separator', 
      icon: '➖',
      category: 'Separadores',
      description: 'Línea horizontal',
      defaultData: { 
        style: 'solid',
        color: '#e9ecef',
        thickness: '1px',
        width: '100%'
      }
    },
    { 
      id: 'block-spacer', 
      title: 'Espaciador', 
      type: 'spacer', 
      icon: '⬜',
      category: 'Separadores',
      description: 'Espacio vertical',
      defaultData: { 
        height: '20px',
        background: 'transparent'
      }
    },
    { 
      id: 'block-divider', 
      title: 'Divisor decorativo', 
      type: 'divider', 
      icon: '✨',
      category: 'Separadores',
      description: 'Separador con icono',
      defaultData: { 
        icon: '★',
        text: '',
        color: '#7048e8'
      }
    },
    
    // Bloques de contenedor
    { 
      id: 'block-container', 
      title: 'Contenedor', 
      type: 'container', 
      icon: '📦',
      category: 'Contenedores',
      description: 'Agrupa otros bloques',
      defaultData: { 
        backgroundColor: '#f8f9fa',
        padding: '20px',
        borderRadius: '8px',
        border: 'none'
      }
    },
    { 
      id: 'block-columns', 
      title: 'Columnas', 
      type: 'columns', 
      icon: '📊',
      category: 'Contenedores',
      description: 'Distribuye en columnas',
      defaultData: { 
        columns: 2,
        gap: '20px',
        layout: '1fr 1fr'
      }
    }
    */
  ];

  const fileInputRef = useRef(null);
  const [uploadingForBlock, setUploadingForBlock] = useState(null);

  // Función para crear bloque desde template
  const createBlockFromTemplate = (template) => {
    let  baseBlock = {};
    if (template.type === "slider-agrupado") {
       baseBlock = {
        id: `block-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        title: template.title,
        type: template.type,
        icon: template.icon,
        category: template.category,
        description: template.description,
        data: { ...template.defaultData },
        valueGroup : template.valueGroup,
        settings: {
          showIcon: true,
          showTitle: true,
          className: '',
          animation: 'none'
        }
      };

    }else{
      baseBlock = {
        id: `block-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        title: template.title,
        type: template.type,
        icon: template.icon,
        category: template.category,
        description: template.description,
        data: { ...template.defaultData },
        settings: {
          showIcon: true,
          showTitle: true,
          className: '',
          animation: 'none'
        }
      };
    }

    // Personalizar según el tipo de bloque
    switch(template.type) {
      case 'image':
        return {
          ...baseBlock,
          data: {
            ...baseBlock.data,
            url: 'https://via.placeholder.com/300x200',
            alt: 'Imagen de ejemplo'
          }
        };
      
      case 'gallery':
        return {
          ...baseBlock,
          data: {
            ...baseBlock.data,
            images: [
              'https://via.placeholder.com/300x200/7048e8/ffffff?text=Imagen+1',
              'https://via.placeholder.com/300x200/37b24d/ffffff?text=Imagen+2',
              'https://via.placeholder.com/300x200/f03e3e/ffffff?text=Imagen+3'
            ]
          }
        };
      
      case 'image-text':
        return {
          ...baseBlock,
          data: {
            ...baseBlock.data,
            imageUrl: 'https://via.placeholder.com/200x150',
            text: 'Texto que acompaña a la imagen. Puedes editar este contenido.'
          }
        };
      
      case 'heading':
        return {
          ...baseBlock,
          title: 'Título de la sección',
          data: {
            ...baseBlock.data,
            level: 'h2',
            align: 'left'
          }
        };
	      
      case 'paragraph':
        return {
          ...baseBlock,
          title: 'Párrafo',
          data: {
            ...baseBlock.data,
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
          }
        };
      case 'container':
        return {
          ...baseBlock,
          title: 'Contenedor',
          children: []
        };
      
      case 'columns':
        return {
          ...baseBlock,
          title: 'Columnas',
          children: [[], []] 
        };
      
      default:
        return baseBlock;
    }
  };

  // Handlers para drag and drop
  const handleDragStart = (e, block, fromAvailable = true) => {
    e.dataTransfer.setData('application/json', JSON.stringify({
      ...block,
      fromAvailable
    }));
    e.dataTransfer.effectAllowed = 'move';
    setDraggedBlock(block);
    
    // Crear ghost personalizado
    const ghost = document.createElement('div');
    ghost.className = 'drag-ghost';
    ghost.innerHTML = `
      <div class="drag-ghost-content">
        <span class="drag-ghost-icon">${block.icon}</span>
        <span class="drag-ghost-title">${block.title}</span>
      </div>
    `;
    document.body.appendChild(ghost);
    e.dataTransfer.setDragImage(ghost, 20, 20);
    setTimeout(() => document.body.removeChild(ghost), 0);
  };

  // 🆕 NUEVA FUNCIÓN: handleBlockReorder
  const handleBlockReorder = (data, targetIndex) => {
    if (data.sourceIndex !== undefined && targetIndex !== null && data.sourceIndex !== targetIndex) {
      setMenuBlocks(prev => {
        const newBlocks = [...prev];
        const [movedBlock] = newBlocks.splice(data.sourceIndex, 1);
        newBlocks.splice(targetIndex, 0, movedBlock);
        return newBlocks;
      });
    }
  };

  const handleDrop = (e, targetIndex = null) => {
    e.preventDefault();
    
    try {
      const data = JSON.parse(e.dataTransfer.getData('application/json'));
      
      if (data.fromAvailable) {
        // Nuevo bloque desde el panel derecho
        const newBlock = createBlockFromTemplate(data);
        
        if (targetIndex !== null) {
          setMenuBlocks(prev => {
            const newBlocks = [...prev];
            newBlocks.splice(targetIndex, 0, newBlock);
            return newBlocks;
          });
        } else {
          setMenuBlocks(prev => [...prev, newBlock]);
        }
      } else {
        // Reordenar bloques existentes
        handleBlockReorder(data, targetIndex);
      }
    } catch (error) {
      console.error('Error en drop:', error);
    }
    
    setDraggedBlock(null);
  };

  // Funciones de actualización
  const updateBlockData = (index, field, value) => {
  	console.log(index, field, value);
    setMenuBlocks(prev => {
      const newBlocks = [...prev];
      if (!newBlocks[index].data) newBlocks[index].data = {};
      newBlocks[index].data[field] = value;
      return newBlocks;
    });
  };


 const updateBlockDataParrafo = (index, field, value) => {

    console.log(index, field, value);

    setMenuBlocks(prev => {

        const newBlocks = [...prev];

        if (!newBlocks[index].data) {
            newBlocks[index].data = {};
        }

        newBlocks[index] = {
            ...newBlocks[index],
            data: {
                ...newBlocks[index].data,
                [field]: value
            }
        };

        return newBlocks;
    });
};


  const updateBlockSettings = (index, field, value) => {
    setMenuBlocks(prev => {
      const newBlocks = [...prev];
      if (!newBlocks[index].settings) newBlocks[index].settings = {};
      newBlocks[index].settings[field] = value;
      return newBlocks;
    });
  };

  const updateBlockTitle = (index, newTitle) => {
    setMenuBlocks(prev => {
      const newBlocks = [...prev];
      newBlocks[index].title = newTitle;
      return newBlocks;
    });
  };

  const updateBlockSubTitle = (index, newTitle) => {
    setMenuBlocks(prev => {
      const newBlocks = [...prev];
      newBlocks[index].subtitle = newTitle;
      return newBlocks;
    });
  };

  const updateBlockSelectBloque = (e,index, newTitle) => {
      const option = e.target.selectedOptions[0];
      const link = option.dataset.link;

    if (newTitle !== "") {      
      setMenuBlocks(prev => {
        const newBlocks = [...prev];
        newBlocks[index].valuecode = newTitle;
        newBlocks[index].url = link;
        return newBlocks;
      });
    }
  };
  
  const updateBlockSelectBloqueAgrupado = (e,index, newTitle) => {
      window.aaa= e;
      const option = e.target.selectedOptions[0];
      const link = option.dataset.link;

      const new_item = {"code": newTitle, "title": option.text, "link" : link }

    if (newTitle !== "" && newTitle!="0") {


      setMenuBlocks(prev => {
        const newBlocks = [...prev];

        newBlocks[index].valueGroup.push(new_item);
        
        //console.log(new_item,newBlocks[index].valueGroup)
        
        const linkPrint = newBlocks[index].valueGroup.map(function(params) {
            //return params.link
            return params.link.replace(/\/c\//g, "");
        }).toString()


        newBlocks[index].url = linkPrint;
        return newBlocks;
      });
    }
  };


  const onRemove = (e,index, newTitle) => {
      window.aaa= e;
      const option = e.target.selectedOptions[0];
      const link = option.dataset.link;

      const new_item = {"code": newTitle, "title": option.text, "link" : link }

    if (newTitle !== "" && newTitle!="0") {


      setMenuBlocks(prev => {
        const newBlocks = [...prev];

        newBlocks[index].valueGroup.push(new_item);
        
        //console.log(new_item,newBlocks[index].valueGroup)
        
        const linkPrint = newBlocks[index].valueGroup.map(function(params) {
            //return params.link
            return params.link.replace(/\/c\//g, "");
        }).toString()


        newBlocks[index].url = linkPrint;
        return newBlocks;
      });
    }
  };

  

  const updateBlockSelectTipoAgrupacion = (e,index, newTitle) => {
      const option = e.target.selectedOptions[0];
      const link = option.dataset.link;

    if (newTitle !== "") {      
      setMenuBlocks(prev => {
        const newBlocks = [...prev];
        newBlocks[index].tipoAgrupacion = newTitle;
        //newBlocks[index].url = link;
        return newBlocks;
      });
    }
  };

  const updateBlockUrl = (index, newTitle) => {
    setMenuBlocks(prev => {
      const newBlocks = [...prev];
      newBlocks[index].url  = newTitle;
      return newBlocks;
    });
  };


 
  // Función para renderizar el contenido según el tipo de bloque
  const renderBlockContent = (block, index) => {
    switch(block.type) {
      // Bloques de imagen
      case 'image':
        return (
          <div className="block-image">
            {block.data.url ? (
              <img 
                src={block.data.url} 
                alt={block.data.alt || block.title}
                style={{
                  width: block.data.width || '100%',
                  height: block.data.height || 'auto',
                  borderRadius: block.data.borderRadius || '0'
                }}
              />
            ) : (
              <div className="image-placeholder">
                <span>🖼️</span>
                <p>Sin imagen seleccionada</p>
              </div>
            )}
            {block.data.caption && (
              <div className="image-caption">{block.data.caption}</div>
            )}
          </div>
        );


      case 'advanced-gallery':
      case 'banner-gallery':

        return (
          <div className="advanced-gallery-block">
            {/* Grid de imágenes */}
                    <div className="select-view">                    
                      <select>
                      <option value="web">Web (Desktop)</option>
                      <option value="mobile">Móvil</option>
                      <option value="all">Todos los dispositivos</option>
                      </select>
                    </div>
            
            <div 
              className="gallery-grid"
              style={{
                display: 'grid',
                gridTemplateColumns: `repeat(${block.data.columns || 3}, 1fr)`,
                gap: block.data.gap || '10px'
              }}
            >            
              {block.data.images && block.data.images.length > 0 ? (
                block.data.images.map((img, imgIndex) => {
                  const hasLink = img.link && img.link.url && img.link.url.trim() !== '';
                  const linkTarget = block.data.openLinksInNewTab ? '_blank' : (img.link?.target || '_self');
                  
                  return (
                    <div 
                      key={img.id} 
                      className={`gallery-item ${hasLink ? 'has-link' : ''} ${block.data.enableDrag ? 'draggable' : ''}`}
                      draggable={block.data.enableDrag}
                      onDragStart={(e) => {
                        if (!block.data.enableDrag) return;
                        e.dataTransfer.setData('text/plain', JSON.stringify({
                          blockIndex: index,
                          imageIndex: imgIndex,
                          imageId: img.id
                        }));
                        e.currentTarget.classList.add('dragging');
                      }}
                      onDragOver={(e) => {
                        e.preventDefault();
                        e.currentTarget.classList.add('drag-over');
                      }}
                      onDragLeave={(e) => {
                        e.currentTarget.classList.remove('drag-over');
                      }}
                      onDrop={(e) => {
                        e.preventDefault();
                        e.currentTarget.classList.remove('drag-over');
                        
                        try {
                          const data = JSON.parse(e.dataTransfer.getData('text/plain'));
                          if (data.blockIndex === index && data.imageIndex !== imgIndex) {
                            reorderGalleryImages(index, data.imageIndex, imgIndex);
                          }
                        } catch (error) {
                          console.error('Error reordenando:', error);
                        }
                      }}
                      onDragEnd={(e) => {
                        e.currentTarget.classList.remove('dragging');
                      }}
                    >
                      {/* Contenedor de la imagen con o sin link */}
                      {hasLink ? (
                        <a 
                          href={img.link.url} 
                          target={linkTarget}
                          rel={img.link.rel || 'noopener noreferrer'}
                          className="gallery-link"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <img 
                            src={img.url} 
                            alt={img.alt || img.name}
                            className="gallery-thumb"
                            title={img.metaTitle || img.alt}
                            loading="lazy"
                          />
                        </a>
                      ) : (
                        <img 
                          src={img.url} 
                          alt={img.alt || img.name}
                          className="gallery-thumb"
                          title={img.metaTitle || img.alt}
                          loading="lazy"
                        />
                      )}
                      
                      {/* Pie de foto si está activado */}
                      {block.data.showCaptions && img.caption && (
                        <div className="gallery-caption">{img.caption}</div>
                      )}
                      
                      {/* Overlay de información SEO (aparece al hover) */}
                      <div className="image-info-overlay">
                        {img.metaTitle && <span className="meta-title">{img.metaTitle}</span>}
                        {img.seo?.description && (
                          <span className="seo-desc">{img.seo.description.substring(0, 50)}...</span>
                        )}
                      </div>
                      
                      {/* BADGES - Siempre visibles */}
                      <div className="image-badges">
                        {hasLink && (
                          <span className="badge link-badge" title={`Enlace: ${img.link.url}`}>🔗</span>
                        )}
                        {img.metaTitle && (
                          <span className="badge seo-badge" title="Tiene meta title">📌</span>
                        )}
                      </div>
                      
                      {/* CONTROLES - Siempre visibles (fijos en la esquina) */}
                      <div className="image-controls">
                        <button 
                          className="control-btn edit-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            openImageEditModal(index, img.id, img);
                          }}
                          title="Editar metadatos"
                        >
                          ✏️
                        </button>

                        <button 
                          className="control-btn duplicate-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            duplicateGalleryImage(index, img.id);
                          }}
                          title="Duplicar imagen"
                        >
                          📋
                        </button>
                        <button 
                          className="control-btn remove-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            removeGalleryImage(index, img.id);
                          }}
                          title="Eliminar imagen"
                        >
                          🗑️
                        </button>
                      </div>
                      
                      {/* Drag handle para reordenar */}
                      {block.data.enableDrag && (
                        <span className="drag-handle" title="Arrastrar para reordenar">⋮⋮</span>
                      )}
                      
                      {/* Número de imagen */}
                      <span className="image-number">{imgIndex + 1}</span>
                    </div>
                  );
                })
              ) : (
                <div className="gallery-placeholder">
                  <span>🏞️</span>
                  <p>No hay imágenes en la galería</p>
                  <button 
                    className="upload-placeholder-btn"
                    onClick={() => document.getElementById(`gallery-upload-${index}`).click()}
                  >
                    📁 Subir imágenes
                  </button>
                </div>
              )}
            </div>

            {/* Área de subida (si no hay imágenes) */}
            {(!block.data.images || block.data.images.length === 0) && (
              <div className="gallery-upload-area">
                <input
                  type="file"
                  accept="image/*"
                  multiple
                  style={{ display: 'none' }}
                  id={`gallery-upload-${index}`}
                  onChange={(e) => handleGalleryUpload(e, index)}
                />
                <button 
                  className="upload-gallery-btn"
                  onClick={() => document.getElementById(`gallery-upload-${index}`).click()}
                >
                  📁 Subir imágenes
                </button>
                <p className="upload-hint">
                  Selecciona múltiples imágenes (máx 5MB cada una)<br />
                  Formatos: JPG, PNG, GIF, WebP
                </p>
              </div>
            )}

            {/* Footer con acciones */}
            {block.data.images && block.data.images.length > 0 && (
              <div className="gallery-footer">
                <div className="footer-left">
                  <button 
                    className="add-more-btn"
                    onClick={() => document.getElementById(`gallery-upload-${index}`).click()}
                  >
                    + Añadir más imágenes
                  </button>
                  <button 
                    className="action-btn export-btn"
                    onClick={() => exportGalleryMetadata(index)}
                    title="Exportar metadatos"
                  >
                    📥 Exportar metadatos
                  </button>
                  <button 
                    className="action-btn clear-btn"
                    onClick={() => clearAllGalleryImages(index)}
                    title="Vaciar galería"
                  >
                    🗑️ Vaciar todo
                  </button>
                </div>
                <div className="footer-right">
                  <span className="image-count">
                    📸 {block.data.images.length} imagen{block.data.images.length !== 1 ? 'es' : ''}
                  </span>
                </div>
              </div>
            )}

            {/* Input file oculto para subidas */}
            <input
              type="file"
              accept="image/*"
              multiple
              style={{ display: 'none' }}
              id={`gallery-upload-${index}`}
              onChange={(e) => handleGalleryUpload(e, index)}
            />
          </div>
        );


      case 'gallery':
        return (
          <div 
            className="block-gallery"
            style={{
              display: 'grid',
              gridTemplateColumns: `repeat(${block.data.columns || 3}, 1fr)`,
              gap: block.data.gap || '10px'
            }}
          >
            {block.data.images && block.data.images.length > 0 ? (
              block.data.images.map((img, i) => (
                <div key={i} className="gallery-item">
                  <img 
                    src={img} 
                    alt={`Galería ${i + 1}`}
                    style={{
                      aspectRatio: block.data.aspectRatio || '1/1',
                      objectFit: 'cover',
                      width: '100%',
                      height: '100%'
                    }}
                  />
                </div>
              ))
            ) : (
              <div className="gallery-placeholder">
                <span>📸</span>
                <p>Añade imágenes a la galería</p>
              </div>
            )}
          </div>
        );
      
      case 'image-text':
        return (
          <div className={`block-image-text image-${block.data.imagePosition || 'left'}`}>
            <div className="image-container">
              {block.data.imageUrl ? (
                <img src={block.data.imageUrl} alt="Imagen" />
              ) : (
                <div className="image-placeholder">🖼️</div>
              )}
            </div>
            <div className="text-container" style={{ textAlign: block.data.textAlign }}>
              <p>{block.data.text}</p>
            </div>
          </div>
        );
      
      // Bloques de texto
      case 'heading':
        const HeadingTag = block.data.level || 'h2';
        return (
          <HeadingTag 
            className="block-heading"
            style={{
              textAlign: block.data.align,
              color: block.data.color,
              fontSize: block.data.fontSize,
              margin: '0'
            }}
          >
            {block.title}
          </HeadingTag>
        );
      
      case 'subheading':
        const SubHeadingTag = block.data.level || 'h3';
        return (
          <SubHeadingTag 
            className="block-subheading"
            style={{
              textAlign: block.data.align,
              color: block.data.color,
              fontSize: block.data.fontSize,
              margin: '0'
            }}
          >
            {block.title}
          </SubHeadingTag>
        );
      
      case 'paragraph':
        return (
          <p 
            className="block-paragraph2"
            style={{
              textAlign: block.data.align,
              color: block.data.color,
              margin: '0'
            }}
          >
            {block.data.content}
          </p>
        );
      
      // Bloques de separadores
      case 'separator':
        return (
          <hr 
            className="block-separator"
            style={{
              border: 'none',
              borderTop: `${block.data.thickness || '1px'} ${block.data.style || 'solid'} ${block.data.color || '#e9ecef'}`,
              width: block.data.width || '100%',
              margin: '10px 0'
            }}
          />
        );
      
      case 'spacer':
        return (
          <div 
            className="block-spacer"
            style={{
              height: block.data.height || '20px',
              background: block.data.background || 'transparent'
            }}
          />
        );
      
      case 'divider':
        return (
          <div className="block-divider" style={{ color: block.data.color }}>
            <span className="divider-line"></span>
            <span className="divider-icon">{block.data.icon || '★'}</span>
            {block.data.text && <span className="divider-text">{block.data.text}</span>}
            <span className="divider-line"></span>
          </div>
        );
      
      // Bloques de contenedor
      case 'container':
        return (
          <div 
            className="block-container"
            style={{
              backgroundColor: block.data.backgroundColor,
              padding: block.data.padding,
              borderRadius: block.data.borderRadius,
              border: block.data.border
            }}
          >
            {block.children && block.children.length > 0 ? (
              block.children.map((child, childIndex) => (
                <div key={childIndex} className="container-child">
                  <p>Bloque hijo {childIndex + 1}</p>
                </div>
              ))
            ) : (
              <div className="container-placeholder">
                Arrastra bloques aquí
              </div>
            )}
          </div>
        );
      
      case 'columns':
        return (
          <div 
            className="block-columns"
            style={{
              display: 'grid',
              gridTemplateColumns: block.data.layout || `repeat(${block.data.columns}, 1fr)`,
              gap: block.data.gap || '20px'
            }}
          >
            {Array.from({ length: block.data.columns || 2 }).map((_, colIndex) => (
              <div key={colIndex} className="column">
                <div className="column-placeholder">
                  Columna {colIndex + 1}
                </div>
              </div>
            ))}
          </div>
        );
      
      // Bloques de navegación
      default:
        return (
          <div className="block-link">
            {block.settings?.showIcon && (
              <span className="block-icon">{block.icon}</span>
            )}
            {block.settings?.showTitle && (
              <span className="block-title">{block.title}</span>
            )}
            {block.data?.url && block.data.url !== '#' && (
              <span className="block-url">{block.data.url}</span>
            )}
          </div>
        );
    }
  };


  // Editor específico para cada tipo de bloque
  const renderBlockEditorSlider = (block, index) => {
    return (
      <div className="block-editor">
        {/* Campos comunes */}
        <div className="editor-section">
          <h4>Configuración básica</h4>
          <div className="editor-field">
            <label>Título:</label>
            <input
              type="text"
              value={block.title}
              onChange={(e) => updateBlockTitle(index, e.target.value)}
              placeholder="Título del bloque"
            />
          </div>

          <div className="editor-field">
            <label>Sub Título:</label>
            <input
              type="text"
              value={block.subtitle}
              onChange={(e) => updateBlockSubTitle(index, e.target.value)}
              placeholder="Sub Título del bloque"
            />
          </div>

          <div className="editor-field">
            <label>Lista del bloque:</label>
            {
              block.type === "slider-categoria" ?
                <select 
                  name="valuecode"
                  value = {block.valuecode}
                  onChange={(e) => updateBlockSelectBloque(e,index, e.target.value)}
                >
                  <option>Seleccione un item</option>
                        {
                          window.Listcategory.map((entry,enkey) =>
                            <option key={enkey} data-link={entry.url} value={entry.id}>{entry.title}</option>
                          )
                        }              
                </select>
              :
              null
            }

            {
              block.type === "slider-transversal" ?
                <select 
                  name="valuecode"
                  value = {block.valuecode}
                  onChange={(e) => updateBlockSelectBloque(e,index, e.target.value)}
                >
                  <option>Seleccione un item</option>
                        {
                          window.Listtransversal.map((entry,enkey) =>
                            <option key={enkey} data-link={entry.url} value={entry.id}>{entry.title}</option>
                          )
                        }              
                </select>
              :
              null
            }

          </div>


          <div className="editor-field">
            <label>URL:</label>
            <input
              type="text"
              value={block.url}
              onChange={(e) => updateBlockUrl(index, e.target.value)}
              placeholder="Hipervinculo del bloque"
            />
          </div>

          <div className="editor-field">
            <label>Clase CSS:</label>
            <input
              type="text"
              value={block.settings?.className || ''}
              onChange={(e) => updateBlockSettings(index, 'className', e.target.value)}
              placeholder="clase-css"
            />
          </div>
        </div>

        {/* Campos específicos según el tipo */}
        <div className="editor-section">
          <h4>Configuración específica</h4>
          
          {block.type === 'image' && (
            <>
              <div className="editor-field">
                <label>URL imagen:</label>
                <input
                  type="text"
                  value={block.data.url || ''}
                  onChange={(e) => updateBlockData(index, 'url', e.target.value)}
                  placeholder="https://ejemplo.com/imagen.jpg"
                />
              </div>
              <div className="editor-field">
                <label>Texto alternativo:</label>
                <input
                  type="text"
                  value={block.data.alt || ''}
                  onChange={(e) => updateBlockData(index, 'alt', e.target.value)}
                  placeholder="Descripción de la imagen"
                />
              </div>
              <div className="editor-row">
                <div className="editor-field small">
                  <label>Ancho:</label>
                  <input
                    type="text"
                    value={block.data.width || '100%'}
                    onChange={(e) => updateBlockData(index, 'width', e.target.value)}
                  />
                </div>
                <div className="editor-field small">
                  <label>Alto:</label>
                  <input
                    type="text"
                    value={block.data.height || 'auto'}
                    onChange={(e) => updateBlockData(index, 'height', e.target.value)}
                  />
                </div>
              </div>
              <div className="editor-field">
                <label>Borde redondeado:</label>
                <input
                  type="text"
                  value={block.data.borderRadius || '0'}
                  onChange={(e) => updateBlockData(index, 'borderRadius', e.target.value)}
                  placeholder="8px"
                />
              </div>
              <button 
                className="upload-button"
                onClick={() => {
                  setUploadingForBlock(index);
                  fileInputRef.current?.click();
                }}
              >
                📁 Subir imagen
              </button>
            </>
          )}



          {block.type === 'gallery' && (
            <>
              <div className="editor-field">
                <label>Columnas:</label>
                <input
                  type="number"
                  min="1"
                  max="6"
                  value={block.data.columns || 3}
                  onChange={(e) => updateBlockData(index, 'columns', parseInt(e.target.value))}
                />
              </div>
              <div className="editor-field">
                <label>Espaciado:</label>
                <input
                  type="text"
                  value={block.data.gap || '10px'}
                  onChange={(e) => updateBlockData(index, 'gap', e.target.value)}
                  placeholder="10px"
                />
              </div>
              <div className="editor-field">
                <label>Aspect ratio:</label>
                <select
                  value={block.data.aspectRatio || '1/1'}
                  onChange={(e) => updateBlockData(index, 'aspectRatio', e.target.value)}
                >
                  <option value="1/1">Cuadrado (1:1)</option>
                  <option value="16/9">Panorámico (16:9)</option>
                  <option value="4/3">Clásico (4:3)</option>
                  <option value="3/2">Rectangular (3:2)</option>
                </select>
              </div>
              <div className="editor-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={block.data.lightbox || false}
                    onChange={(e) => updateBlockData(index, 'lightbox', e.target.checked)}
                  />
                  Abrir en lightbox
                </label>
              </div>
            </>
          )}

          { ["slider-categoria","slider-transversal"].includes(block.type)  && (
                      <>

                        {/* NUEVO CAMPO: Input file para imágenes */}
                        <div className="advanced-field image-field">
                          <label><p>Imagen del Banner Lateral <br/>width 280px height 390px</p></label>
                          <div className="image-input-container">
                            <input
                              type="file"
                              accept="image/*"
                              className="item-image-input"
                              id={`image-${block.id}`}
                              onChange={(e) => handleImageUpload(e, block.id)}
                              style={{ display: 'none' }}
                            />
                            
                            <div className="image-preview-container">
                              {block.imagePreview ? (
                                <div className="image-preview">
                                  <img 
                                    src={block.imagePreview} 
                                    alt="Preview" 
                                    className="preview-thumb"
                                  />
                                  <button 
                                    className="remove-image-btn"
                                    onClick={() => removeImage(block.id)}
                                    type="button"
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                              ) : (
                                <button 
                                  className="upload-image-btn"
                                  onClick={() => document.getElementById(`image-${block.id}`).click()}
                                  type="button"
                                >
                                  <i className="fas fa-upload"></i>
                                  <span>Seleccionar imagen</span>
                                </button>
                              )}
                            </div>
                            
                            {block.imageFile && (
                              <div className="image-info">
                                <small>{block.imageFile.name}</small>
                              </div>
                            )}
                          </div>
                        </div>



                      </>
                    )}
                    
          {block.type === 'image-text' && (
            <>
              <div className="editor-field">
                <label>Posición imagen:</label>
                <select
                  value={block.data.imagePosition || 'left'}
                  onChange={(e) => updateBlockData(index, 'imagePosition', e.target.value)}
                >
                  <option value="left">Izquierda</option>
                  <option value="right">Derecha</option>
                  <option value="top">Arriba</option>
                  <option value="bottom">Abajo</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Texto:</label>
                <textarea
                  value={block.data.text || ''}
                  onChange={(e) => updateBlockData(index, 'text', e.target.value)}
                  rows="3"
                />
              </div>
            </>
          )}

          {['heading', 'subheading'].includes(block.type) && (
            <>
              <div className="editor-field">
                <label>Nivel:</label>
                <select
                  value={block.data.level || 'h2'}
                  onChange={(e) => updateBlockData(index, 'level', e.target.value)}
                >
                  <option value="h1">H1 - Título principal</option>
                  <option value="h2">H2 - Sección</option>
                  <option value="h3">H3 - Subsección</option>
                  <option value="h4">H4 - Detalle</option>
                  <option value="h5">H5 - Menor</option>
                  <option value="h6">H6 - Mínimo</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Alineación:</label>
                <select
                  value={block.data.align || 'left'}
                  onChange={(e) => updateBlockData(index, 'align', e.target.value)}
                >
                  <option value="left">Izquierda</option>
                  <option value="center">Centro</option>
                  <option value="right">Derecha</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Color:</label>
                <input
                  type="color"
                  value={block.data.color || '#000000'}
                  onChange={(e) => updateBlockData(index, 'color', e.target.value)}
                />
              </div>
              <div className="editor-field">
                <label>Tamaño fuente:</label>
                <input
                  type="text"
                  value={block.data.fontSize || '24px'}
                  onChange={(e) => updateBlockData(index, 'fontSize', e.target.value)}
                  placeholder="24px"
                />
              </div>
            </>
          )}

          {block.type === 'paragraph' && (
  <>
    <div className="editor-field">
      <label>Contenido:</label>
      <ReactQuill
        theme="snow"
        value={block.data.content || ''}
        onChange={(content) => updateBlockData(index, 'content', content)}
        modules={quillModules}
        formats={quillFormats}
        placeholder="Escribe tu contenido aquí..."
        className="quill-editor"
      />
    </div>
    <div className="editor-field">
      <label>Alineación:</label>
      <select
        value={block.data.align || 'left'}
        onChange={(e) => updateBlockData(index, 'align', e.target.value)}
      >
        <option value="left">Izquierda</option>
        <option value="center">Centro</option>
        <option value="right">Derecha</option>
        <option value="justify">Justificado</option>
      </select>
    </div>
    <div className="editor-field">
      <label>Color del texto:</label>
      <input
        type="color"
        value={block.data.color || '#333333'}
        onChange={(e) => updateBlockData(index, 'color', e.target.value)}
      />
    </div>
  </>
)}

          {block.type === 'separator' && (
            <>
              <div className="editor-field">
                <label>Estilo:</label>
                <select
                  value={block.data.style || 'solid'}
                  onChange={(e) => updateBlockData(index, 'style', e.target.value)}
                >
                  <option value="solid">Sólido</option>
                  <option value="dashed">Discontinuo</option>
                  <option value="dotted">Punteado</option>
                  <option value="double">Doble</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Color:</label>
                <input
                  type="color"
                  value={block.data.color || '#e9ecef'}
                  onChange={(e) => updateBlockData(index, 'color', e.target.value)}
                />
              </div>
              <div className="editor-field">
                <label>Grosor:</label>
                <input
                  type="text"
                  value={block.data.thickness || '1px'}
                  onChange={(e) => updateBlockData(index, 'thickness', e.target.value)}
                  placeholder="1px"
                />
              </div>
            </>
          )}
        </div>

        {/* Opciones de visualización */}
        <div className="editor-section">
          <h4>Opciones de visualización</h4>
          <div className="editor-checkboxes">
            <label>
              <input
                type="checkbox"
                checked={block.settings?.showIcon !== false}
                onChange={(e) => updateBlockSettings(index, 'showIcon', e.target.checked)}
              />
              Mostrar icono
            </label>
            <label>
              <input
                type="checkbox"
                checked={block.settings?.showTitle !== false}
                onChange={(e) => updateBlockSettings(index, 'showTitle', e.target.checked)}
              />
              Mostrar título
            </label>
          </div>
        </div>
      </div>
    );
  };




  // Editor específico para cada tipo de bloque
  const renderBlockEditorSliderAgrupado = (block, index) => {
    //console.log(block,block.tipoAgrupacion)
    return (
      <div className="block-editor">
        {/* Campos comunes */}
        <div className="editor-section">
          <h4>Configuración básica</h4>
          <div className="editor-field">
            <label>Título:</label>
            <input
              type="text"
              value={block.title}
              onChange={(e) => updateBlockTitle(index, e.target.value)}
              placeholder="Título del bloque"
            />
          </div>

          <div className="editor-field">
            <label>Sub Título:</label>
            <input
              type="text"
              value={block.subtitle}
              onChange={(e) => updateBlockSubTitle(index, e.target.value)}
              placeholder="Sub Título del bloque"
            />
          </div>


          <div className="editor-field">
            <label>Tipo de Agrupación:</label>
                <select 
                  name="tipoAgrupacion"
                  value = {block.tipoAgrupacion}
                  onChange={(e) => updateBlockSelectTipoAgrupacion(e,index, e.target.value)}
                >
                  <option>Seleccione un item</option>
                  <option value="category">Categoria</option>
                  <option value="transversal">Transversal</option>
                </select>

          </div>

          <div className="editor-field">
            <label>Lista del bloque:</label>
            {
              block.tipoAgrupacion === "category" ?
                <select 
                  onChange={(e) => updateBlockSelectBloqueAgrupado(e,index, e.target.value)}
                >
                  <option value="0">Seleccione un item</option>
                        {
                          window.Listcategory.map((entry,enkey) =>
                            <option key={enkey} data-link={entry.url} value={entry.code_backoffice}>{entry.title}</option>
                          )
                        }              
                </select>
              :
              null
            }

            {
              block.tipoAgrupacion === "transversal" ?
                <select 
                  onChange={(e) => updateBlockSelectBloqueAgrupado(e,index, e.target.value)}
                >
                  <option>Seleccione un item</option>
                        {
                          window.Listtransversal.map((entry,enkey) =>
                            <option key={enkey} data-link={entry.url} value={entry.code_backoffice}>{entry.title}</option>
                          )
                        }              
                </select>
              :
              null
            }

          </div>

          <div className="Tag-group-editor-page">

            <TagGroup
              items={block.valueGroup}
              indexPadre = {index}
              onRemove={(indexChild) => {
                setMenuBlocks(
                prev => {

                  const oldBlock = [...prev];
                  //console.log(prev,oldBlock,index,indexChild,oldBlock[index].valueGroup)                  
                  const newGroup = oldBlock[index].valueGroup.filter(function(quitar,indexquitar){
                    return indexquitar !== indexChild
                  }
                  );

                  oldBlock[index].valueGroup = newGroup

                  const linkPrint = newGroup
                    .map(p => p.link.replace(/\/c\//g, ""))
                    .toString();

                    oldBlock[index].url = linkPrint;

                  return oldBlock;
                });
              }}
            />

          </div>

          <div className="editor-field">
            <label>URL:</label>
            <input disabled
              type="text"
              value={block.url}
              onChange={(e) => updateBlockUrl(index, e.target.value)}
              placeholder="Hipervinculo del bloque"
            />
          </div>

          <div className="editor-field">
            <label>Clase CSS:</label>
            <input
              type="text"
              value={block.settings?.className || ''}
              onChange={(e) => updateBlockSettings(index, 'className', e.target.value)}
              placeholder="clase-css"
            />
          </div>
        </div>

        {/* Campos específicos según el tipo */}
        <div className="editor-section">
          <h4>Configuración específica</h4>
          
          { ["slider-agrupado"].includes(block.type)  && (
                      <>

                        {/* NUEVO CAMPO: Input file para imágenes */}
                        <div className="advanced-field image-field">
                          <label><p>Imagen del Banner Lateral <br/>width 280px height 390px</p></label>
                          <div className="image-input-container">
                            <input
                              type="file"
                              accept="image/*"
                              className="item-image-input"
                              id={`image-${block.id}`}
                              onChange={(e) => handleImageUpload(e, block.id)}
                              style={{ display: 'none' }}
                            />
                            
                            <div className="image-preview-container">
                              {block.imagePreview ? (
                                <div className="image-preview">
                                  <img 
                                    src={block.imagePreview} 
                                    alt="Preview" 
                                    className="preview-thumb"
                                  />
                                  <button 
                                    className="remove-image-btn"
                                    onClick={() => removeImage(block.id)}
                                    type="button"
                                  >
                                    <i className="fas fa-times"></i>
                                  </button>
                                </div>
                              ) : (
                                <button 
                                  className="upload-image-btn"
                                  onClick={() => document.getElementById(`image-${block.id}`).click()}
                                  type="button"
                                >
                                  <i className="fas fa-upload"></i>
                                  <span>Seleccionar imagen</span>
                                </button>
                              )}
                            </div>
                            
                            {block.imageFile && (
                              <div className="image-info">
                                <small>{block.imageFile.name}</small>
                              </div>
                            )}
                          </div>
                        </div>



                      </>
                    )}
               

        </div>

        {/* Opciones de visualización */}
        <div className="editor-section">
          <h4>Opciones de visualización</h4>
          <div className="editor-checkboxes">
            <label>
              <input
                type="checkbox"
                checked={block.settings?.showIcon !== false}
                onChange={(e) => updateBlockSettings(index, 'showIcon', e.target.checked)}
              />
              Mostrar icono
            </label>
            <label>
              <input
                type="checkbox"
                checked={block.settings?.showTitle !== false}
                onChange={(e) => updateBlockSettings(index, 'showTitle', e.target.checked)}
              />
              Mostrar título
            </label>
          </div>
        </div>
      </div>
    );
  };




  // Editor específico para cada tipo de bloque
  const renderBlockEditor = (block, index) => {
    switch(block.type) {
case 'advanced-gallery':
case 'banner-gallery':  
  return (
    <div className="block-editor">
      {/* Configuración general */}
      <div className="editor-section">
        <h4>⚙️ Configuración de galería</h4>
        
        <div className="editor-row">
          <div className="editor-field">
            <label>Columnas:</label>
            <input
              type="number"
              min="1"
              max="6"
              value={block.data.columns || 3}
              onChange={(e) => updateBlockData(index, 'columns', parseInt(e.target.value))}
            />
          </div>

        </div>


      </div>

      {/* Input file oculto para subidas */}
      <input
        type="file"
        accept="image/*"
        multiple
        style={{ display: 'none' }}
        id={`gallery-upload-${index}`}
        onChange={(e) => handleGalleryUpload(e, index)}
      />
    </div>
  );
  default:

    return (
      <div className="block-editor">
        {/* Campos comunes */}
        <div className="editor-section">
          <h4>Configuración básica</h4>
          <div className="editor-field">
            <label>Título:</label>
            <input
              type="text"
              value={block.title}
              onChange={(e) => updateBlockTitle(index, e.target.value)}
              placeholder="Título del bloque"
            />
          </div>

          <div className="editor-field">
            <label>Clase CSS:</label>
            <input
              type="text"
              value={block.settings?.className || ''}
              onChange={(e) => updateBlockSettings(index, 'className', e.target.value)}
              placeholder="clase-css"
            />
          </div>
        </div>

        {/* Campos específicos según el tipo */}
        <div className="editor-section">
          <h4>Configuración específica</h4>
          
          {block.type === 'image' && (
            <>
              <div className="editor-field">
                <label>URL imagen:</label>
                <input
                  type="text"
                  value={block.data.url || ''}
                  onChange={(e) => updateBlockData(index, 'url', e.target.value)}
                  placeholder="https://ejemplo.com/imagen.jpg"
                />
              </div>
              <div className="editor-field">
                <label>Texto alternativo:</label>
                <input
                  type="text"
                  value={block.data.alt || ''}
                  onChange={(e) => updateBlockData(index, 'alt', e.target.value)}
                  placeholder="Descripción de la imagen"
                />
              </div>
              <div className="editor-row">
                <div className="editor-field small">
                  <label>Ancho:</label>
                  <input
                    type="text"
                    value={block.data.width || '100%'}
                    onChange={(e) => updateBlockData(index, 'width', e.target.value)}
                  />
                </div>
                <div className="editor-field small">
                  <label>Alto:</label>
                  <input
                    type="text"
                    value={block.data.height || 'auto'}
                    onChange={(e) => updateBlockData(index, 'height', e.target.value)}
                  />
                </div>
              </div>
              <div className="editor-field">
                <label>Borde redondeado:</label>
                <input
                  type="text"
                  value={block.data.borderRadius || '0'}
                  onChange={(e) => updateBlockData(index, 'borderRadius', e.target.value)}
                  placeholder="8px"
                />
              </div>
              <button 
                className="upload-button"
                onClick={() => {
                  setUploadingForBlock(index);
                  fileInputRef.current?.click();
                }}
              >
                📁 Subir imagen
              </button>
            </>
          )}

          {block.type === 'gallery' && (
            <>
              <div className="editor-field">
                <label>Columnas:</label>
                <input
                  type="number"
                  min="1"
                  max="6"
                  value={block.data.columns || 3}
                  onChange={(e) => updateBlockData(index, 'columns', parseInt(e.target.value))}
                />
              </div>
              <div className="editor-field">
                <label>Espaciado:</label>
                <input
                  type="text"
                  value={block.data.gap || '10px'}
                  onChange={(e) => updateBlockData(index, 'gap', e.target.value)}
                  placeholder="10px"
                />
              </div>
              <div className="editor-field">
                <label>Aspect ratio:</label>
                <select
                  value={block.data.aspectRatio || '1/1'}
                  onChange={(e) => updateBlockData(index, 'aspectRatio', e.target.value)}
                >
                  <option value="1/1">Cuadrado (1:1)</option>
                  <option value="16/9">Panorámico (16:9)</option>
                  <option value="4/3">Clásico (4:3)</option>
                  <option value="3/2">Rectangular (3:2)</option>
                </select>
              </div>
              <div className="editor-checkbox">
                <label>
                  <input
                    type="checkbox"
                    checked={block.data.lightbox || false}
                    onChange={(e) => updateBlockData(index, 'lightbox', e.target.checked)}
                  />
                  Abrir en lightbox
                </label>
              </div>
            </>
          )}

          {block.type === 'image-text' && (
            <>
              <div className="editor-field">
                <label>Posición imagen:</label>
                <select
                  value={block.data.imagePosition || 'left'}
                  onChange={(e) => updateBlockData(index, 'imagePosition', e.target.value)}
                >
                  <option value="left">Izquierda</option>
                  <option value="right">Derecha</option>
                  <option value="top">Arriba</option>
                  <option value="bottom">Abajo</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Texto:</label>
                <textarea
                  value={block.data.text || ''}
                  onChange={(e) => updateBlockData(index, 'text', e.target.value)}
                  rows="3"
                />
              </div>
            </>
          )}

          {['heading', 'subheading'].includes(block.type) && (
            <>
              <div className="editor-field">
                <label>Nivel:</label>
                <select
                  value={block.data.level || 'h2'}
                  onChange={(e) => updateBlockData(index, 'level', e.target.value)}
                >
                  <option value="h1">H1 - Título principal</option>
                  <option value="h2">H2 - Sección</option>
                  <option value="h3">H3 - Subsección</option>
                  <option value="h4">H4 - Detalle</option>
                  <option value="h5">H5 - Menor</option>
                  <option value="h6">H6 - Mínimo</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Alineación:</label>
                <select
                  value={block.data.align || 'left'}
                  onChange={(e) => updateBlockData(index, 'align', e.target.value)}
                >
                  <option value="left">Izquierda</option>
                  <option value="center">Centro</option>
                  <option value="right">Derecha</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Color:</label>
                <input
                  type="color"
                  value={block.data.color || '#000000'}
                  onChange={(e) => updateBlockData(index, 'color', e.target.value)}
                />
              </div>
              <div className="editor-field">
                <label>Tamaño fuente:</label>
                <input
                  type="text"
                  value={block.data.fontSize || '24px'}
                  onChange={(e) => updateBlockData(index, 'fontSize', e.target.value)}
                  placeholder="24px"
                />
              </div>
            </>
          )}

          {block.type === 'paragraph' && (
            <>
              <div className="editor-field">
                <label>Contenido:</label>
                
                	<EditorTexto
		                value={block.data.content || ''}
		                onChange={(html) => updateBlockDataParrafo(index, 'content', html)}

		            />

              </div>
              <div className="editor-field">
                <label>Alineación:</label>
                <select
                  value={block.data.align || 'left'}
                  onChange={(e) => updateBlockData(index, 'align', e.target.value)}
                >
                  <option value="left">Izquierda</option>
                  <option value="center">Centro</option>
                  <option value="right">Derecha</option>
                  <option value="justify">Justificado</option>
                </select>
              </div>
            </>
          )}

          {block.type === 'separator' && (
            <>
              <div className="editor-field">
                <label>Estilo:</label>
                <select
                  value={block.data.style || 'solid'}
                  onChange={(e) => updateBlockData(index, 'style', e.target.value)}
                >
                  <option value="solid">Sólido</option>
                  <option value="dashed">Discontinuo</option>
                  <option value="dotted">Punteado</option>
                  <option value="double">Doble</option>
                </select>
              </div>
              <div className="editor-field">
                <label>Color:</label>
                <input
                  type="color"
                  value={block.data.color || '#e9ecef'}
                  onChange={(e) => updateBlockData(index, 'color', e.target.value)}
                />
              </div>
              <div className="editor-field">
                <label>Grosor:</label>
                <input
                  type="text"
                  value={block.data.thickness || '1px'}
                  onChange={(e) => updateBlockData(index, 'thickness', e.target.value)}
                  placeholder="1px"
                />
              </div>
            </>
          )}
        </div>

        {/* Opciones de visualización */}
        <div className="editor-section">
          <h4>Opciones de visualización</h4>
          <div className="editor-checkboxes">
            <label>
              <input
                type="checkbox"
                checked={block.settings?.showIcon !== false}
                onChange={(e) => updateBlockSettings(index, 'showIcon', e.target.checked)}
              />
              Mostrar icono
            </label>
            <label>
              <input
                type="checkbox"
                checked={block.settings?.showTitle !== false}
                onChange={(e) => updateBlockSettings(index, 'showTitle', e.target.checked)}
              />
              Mostrar título
            </label>
          </div>
        </div>
      </div>
    );

    }

  };

  // Agrupar bloques por categoría
  const blocksByCategory = availableBlocks.reduce((acc, block) => {
    if (!acc[block.category]) {
      acc[block.category] = [];
    }
    acc[block.category].push(block);
    return acc;
  }, {});



  const saveData = async(event) =>{
    var modaLoading = 
      window.Swal.fire({
        imageUrl: window.path_service+'/images/loading.png',
        title: 'Cargando datos...',
        showConfirmButton: false,
        customClass: 'ms-loading-modal',
          allowOutsideClick: false
      });
            
      if ( ![undefined,"undefined",""].includes(localStorage.token_authlead) ) {

        const processedMenu = await processImagesTree(menuBlocks);



        const bodyjson = {
          id_comercio : 4,
          name: "legales",
          vista : "legales",
          body : processedMenu
        };

        const response = await fetch(window.path_service_website+"/aux/api/save/pages",{method:'POST',body:  JSON.stringify(bodyjson) })
        const data = await response.json()

        if ( data.hasOwnProperty("status") && data.status ) {
              //document.cookie='commerce_lead_token='+data.lead_token;

              window.Swal.fire({
                  icon: 'success',
                  title: data.message,
                  showConfirmButton: false,
                  timer: 2500
                });                   
          //window.location.href = "/confirmacion?process=finish&checkout=simple&orden="+id_orden;
          modaLoading.close();
        }else{
            window.Swal.fire({
                  icon: 'error',
                  title: data.message,
                  showConfirmButton: false,
                  timer: 3500
            }); 
            modaLoading.close();          
        }
        

      }     
    
  }

  return (
<>


{/* Modal para edición de imagen */}
{showImageModal && editingImage && (
  <div className="image-modal-overlay" onClick={() => setShowImageModal(false)}>
    <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="image-modal-header">
        <h3>
          <span className="modal-icon">🖼️</span>
          Editar imagen
        </h3>
        <button 
          className="modal-close-btn"
          onClick={() => setShowImageModal(false)}
        >
          ✕
        </button>
      </div>

      <div className="image-modal-body">
        {/* Preview de la imagen */}
        <div className="modal-image-preview">
          <img 
            src={editingImage.data.url} 
            alt={editingImage.data.name}
            className="preview-img"
          />
          <div className="preview-info">
            <span className="file-name">{editingImage.data.name}</span>
            <span className="file-size">
              {editingImage.data.size ? Math.round(editingImage.data.size / 1024) + ' KB' : ''}
            </span>
          </div>
        </div>

        {/* Pestañas de edición */}
        <div className="modal-tabs">
          <button 
            className={`tab-btn ${editingTab === 'basic' ? 'active' : ''}`}
            onClick={() => setEditingTab('basic')}
          >
            📝 Básico
          </button>
          <button 
            className={`tab-btn ${editingTab === 'seo' ? 'active' : ''}`}
            onClick={() => setEditingTab('seo')}
          >
            🔍 SEO
          </button>
          <button 
            className={`tab-btn ${editingTab === 'link' ? 'active' : ''}`}
            onClick={() => setEditingTab('link')}
          >
            🔗 Enlace
          </button>
          <button 
            className={`tab-btn ${editingTab === 'advanced' ? 'active' : ''}`}
            onClick={() => setEditingTab('advanced')}
          >
            ⚙️ Avanzado
          </button>
        </div>

        {/* Contenido de las pestañas */}
        <div className="modal-tab-content">
          {/* Pestaña Básico */}
          {editingTab === 'basic' && (
            <div className="tab-pane">
              <div className="form-group">
                <label>
                  <span className="label-icon">📌</span>
                  Título de la imagen:
                </label>
                <input
                  type="text"
                  value={editingImage.data.metaTitle || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, metaTitle: e.target.value }
                  })}
                  placeholder="Ej: Producto principal - nombre"
                  className="form-control"
                />
                <small className="field-hint">
                  {editingImage.data.metaTitle?.length || 0}/60 caracteres
                </small>
              </div>

              <div className="form-group">
                <label>
                  <span className="label-icon">📅</span>
                  Publicar el:
                </label>

                <input
                  type="date"
                  className="form-control"
                  id="start"
                  name="trip-start"
                  value={editingImage.data.datepublish || fechaActual}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, datepublish: e.target.value }
                  })}                  
                  min="2018-01-01"
                  max="2080-12-31" />
              </div>

              <div className="form-group">
                <label>
                  <span className="label-icon">📅</span>
                  Fecha Caducidad:
                </label>

                <input
                  className="form-control"
                  type="date"
                  id="start"
                  name="trip-start"
                  value={editingImage.data.dateexpiration || fechaExpirationDefault}
                  min="2018-01-01"
                  max="2080-12-31" 
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, dateexpiration: e.target.value }
                  })}
                  />
              </div>
              

              <div className="form-group">
                <label>
                  <span className="label-icon">🔍</span>
                  Texto alternativo (alt):
                </label>
                <input
                  type="text"
                  value={editingImage.data.alt || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, alt: e.target.value }
                  })}
                  placeholder="Describe la imagen para accesibilidad"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>
                  <span className="label-icon">📝</span>
                  Pie de foto:
                </label>
                <input
                  type="text"
                  value={editingImage.data.caption || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, caption: e.target.value }
                  })}
                  placeholder="Texto que aparece bajo la imagen"
                  className="form-control"
                />
              </div>

              {
                ["banner-gallery"].includes(menuBlocks[editingImage.blockIndex].type) ?

                <div className="form-group">
                  <label>
                    <span className="label-icon">📝</span>
                    Tipo de vista: 
                  </label>
                  <select
                    value={editingImage.data.typeview || 'web'}
                    onChange={(e) => setEditingImage({
                      ...editingImage,
                      data: { ...editingImage.data, typeview: e.target.value }
                    })}
                    className="form-control"
                  >
                    <option value="web">Web (Desktop)</option>
                    <option value="mobile">Móvil</option>
                    <option value="all">Todos los dispositivos</option>
                  </select>                  
                </div>

                :
                null
              }

            </div>
          )}

          {/* Pestaña SEO */}
          {editingTab === 'seo' && (
            <div className="tab-pane">
              <div className="form-group">
                <label>
                  <span className="label-icon">📄</span>
                  Descripción SEO:
                </label>
                <textarea
                  value={editingImage.data.seo?.description || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { 
                      ...editingImage.data, 
                      seo: { ...editingImage.data.seo, description: e.target.value }
                    }
                  })}
                  placeholder="Breve descripción para motores de búsqueda"
                  rows="4"
                  className="form-control"
                />
                <small className="field-hint">
                  {editingImage.data.seo?.description?.length || 0}/160 caracteres
                </small>
              </div>

              <div className="form-group">
                <label>
                  <span className="label-icon">🏷️</span>
                  Keywords (separadas por comas):
                </label>
                <input
                  type="text"
                  value={editingImage.data.seo?.keywords || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { 
                      ...editingImage.data, 
                      seo: { ...editingImage.data.seo, keywords: e.target.value }
                    }
                  })}
                  placeholder="producto, oferta, nuevo"
                  className="form-control"
                />
              </div>

              <div className="seo-preview">
                <h4>Vista previa Google:</h4>
                <div className="google-preview">
                  <div className="preview-url">https://tusitio.com/...</div>
                  <div className="preview-title">
                    {editingImage.data.metaTitle || editingImage.data.name}
                  </div>
                  <div className="preview-description">
                    {editingImage.data.seo?.description || 'Descripción no disponible'}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Pestaña Enlace */}
          {editingTab === 'link' && (
            <div className="tab-pane">
              <div className="form-group">
                <label>
                  <span className="label-icon">🔗</span>
                  URL del enlace:
                </label>
                <input
                  type="url"
                  value={editingImage.data.link?.url || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { 
                      ...editingImage.data, 
                      link: { ...editingImage.data.link, url: e.target.value }
                    }
                  })}
                  placeholder="https://ejemplo.com"
                  className="form-control"
                />
              </div>

              <div className="form-row">
                <div className="form-group half">
                  <label>Abrir en:</label>
                  <select
                    value={editingImage.data.link?.target || '_blank'}
                    onChange={(e) => setEditingImage({
                      ...editingImage,
                      data: { 
                        ...editingImage.data, 
                        link: { ...editingImage.data.link, target: e.target.value }
                      }
                    })}
                    className="form-control"
                  >
                    <option value="_self">Misma ventana</option>
                    <option value="_blank">Nueva ventana</option>
                  </select>
                </div>

                <div className="form-group half">
                  <label>Relación (rel):</label>
                  <select
                    value={editingImage.data.link?.rel || 'noopener noreferrer'}
                    onChange={(e) => setEditingImage({
                      ...editingImage,
                      data: { 
                        ...editingImage.data, 
                        link: { ...editingImage.data.link, rel: e.target.value }
                      }
                    })}
                    className="form-control"
                  >
                    <option value="noopener noreferrer">noopener</option>
                    <option value="nofollow">nofollow</option>
                    <option value="sponsored">sponsored</option>
                    <option value="ugc">ugc</option>
                  </select>
                </div>
              </div>

              {editingImage.data.link?.url && (
                <div className="link-preview">
                  <a 
                    href={editingImage.data.link.url} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="test-link"
                  >
                    🔍 Probar enlace
                  </a>
                </div>
              )}
            </div>
          )}

          {/* Pestaña Avanzado */}
          {editingTab === 'advanced' && (
            <div className="tab-pane">
              <div className="form-group">
                <label>
                  <span className="label-icon">📏</span>
                  Dimensiones:
                </label>
                <div className="dimension-inputs">
                  <input
                    type="text"
                    placeholder="Ancho"
                    value={editingImage.data.width || ''}
                    onChange={(e) => setEditingImage({
                      ...editingImage,
                      data: { ...editingImage.data, width: e.target.value }
                    })}
                    className="form-control small"
                  />
                  <span className="dimension-sep">x</span>
                  <input
                    type="text"
                    placeholder="Alto"
                    value={editingImage.data.height || ''}
                    onChange={(e) => setEditingImage({
                      ...editingImage,
                      data: { ...editingImage.data, height: e.target.value }
                    })}
                    className="form-control small"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>
                  <span className="label-icon">🎨</span>
                  Clases CSS adicionales:
                </label>
                <input
                  type="text"
                  value={editingImage.data.className || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, className: e.target.value }
                  })}
                  placeholder="img-fluid rounded shadow"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>
                  <span className="label-icon">🆔</span>
                  ID del elemento:
                </label>
                <input
                  type="text"
                  value={editingImage.data.elementId || ''}
                  onChange={(e) => setEditingImage({
                    ...editingImage,
                    data: { ...editingImage.data, elementId: e.target.value }
                  })}
                  placeholder="imagen-principal"
                  className="form-control"
                />
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="image-modal-footer">
        <div className="footer-left">
          <button 
            className="btn-danger"
            onClick={() => {
              if (window.confirm('¿Eliminar esta imagen?')) {
                removeGalleryImage(editingImage.blockIndex, editingImage.imageId);
                setShowImageModal(false);
              }
            }}
          >
            🗑️ Eliminar imagen
          </button>
        </div>
        <div className="footer-right">
          <button 
            className="btn-secondary"
            onClick={() => setShowImageModal(false)}
          >
            Cancelar
          </button>
          <button 
            className="btn-primary"
            onClick={() => {
              // Guardar cambios
              const { blockIndex, imageId, data } = editingImage;
              
              // Actualizar meta title
              if (data.metaTitle !== undefined) {
                updateImageMetaTitle(blockIndex, imageId, data.metaTitle);
              }

              // Actualizar meta title
              if (data.datepublish !== undefined) {
                updateDatePublish(blockIndex, imageId, data.datepublish);
              }

              if (data.dateexpiration !== undefined) {
                updateDateExpiration(blockIndex, imageId, data.dateexpiration);
              }              

              // Actualizar alt
              if (data.alt !== undefined) {
                updateImageAlt(blockIndex, imageId, data.alt);
              }
              
              // Actualizar caption
              if (data.caption !== undefined) {
                updateImageCaption(blockIndex, imageId, data.caption);
              }
              
              // Actualizar link
              if (data.link) {
                updateImageLink(blockIndex, imageId, data.link);
              }
              
              // Actualizar SEO description
              if (data.seo?.description !== undefined) {
                updateImageSeoDescription(blockIndex, imageId, data.seo.description);
              }
              
              // Actualizar SEO keywords
              if (data.seo?.keywords !== undefined) {
                updateImageSeoKeywords(blockIndex, imageId, data.seo.keywords);
              }

            // 🆕 NUEVO: Actualizar typeview
            if (data.typeview !== undefined) {
              updateImageTypeView(blockIndex, imageId, data.typeview);
            }              
              
              setShowImageModal(false);
              //showNotification('Imagen actualizada');
            }}
          >
            💾 Guardar cambios
          </button>
        </div>
      </div>
    </div>
  </div>
)}


    <div className="blocks-editor">
      {/* Header */}
      <div className="blocks-header">
        
        <div className="header-actions">
          <button className="btn-primary" onClick={() => saveData()}>
            💾 Guardar menú
          </button>
          <button className="btn-secondary" onClick={() => setMenuBlocks([])}>
            🗑️ Limpiar todo
          </button>
        </div>
      </div>

      <div className="blocks-layout">
        {/* Panel izquierdo - Área de trabajo */}
        <div className="workspace-panel">
          <div className="workspace-header">
            <h2>Estructura de la pagina</h2>
            <span className="block-count">{menuBlocks.length} bloque{menuBlocks.length !== 1 ? 's' : ''}</span>
          </div>
          
          <div 
            className={`workspace-area ${menuBlocks.length === 0 ? 'empty' : ''}`}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e)}
          >
            {menuBlocks.length === 0 ? (
              <div className="empty-state">
                <div className="empty-icon">🎯</div>
                <h3>No hay contenido</h3>
                <p>Arrastra bloques desde el panel derecho</p>
              </div>
            ) : (
              <div className="blocks-list">
                {menuBlocks.map((block, index) => (
                  <div
                    key={block.id}
                    className={`menu-block ${selectedBlock === index ? 'selected' : ''}`}
                    draggable
                    onDragStart={(e) => {
                      e.dataTransfer.setData('application/json', JSON.stringify({
                        ...block,
                        fromAvailable: false,
                        sourceIndex: index
                      }));
                    }}
                    onDragOver={(e) => {
                      e.preventDefault();
                      e.currentTarget.classList.add('drop-target');
                    }}
                    onDragLeave={(e) => {
                      e.currentTarget.classList.remove('drop-target');
                    }}
                    onDrop={(e) => handleDrop(e, index)}
                    onClick={() => setSelectedBlock(index === selectedBlock ? null : index)}
                  >
                    <div className="block-header">
                      <span className="block-drag-handle">⋮⋮</span>
                      <span className="block-type-icon">{block.icon}</span>
                      <span className="block-type-label">{block.type}</span>
                      <span className="block-category">{block.category}</span>
                      <div className="block-actions">
                        <button 
                          className="action-btn"
                          onClick={(e) => {
                            e.stopPropagation();
                            setEditingBlock(index === editingBlock ? null : index);
                          }}
                        >
                          ⚙️
                        </button>
                        <button 
                          className="action-btn delete"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (window.confirm('¿Eliminar este bloque?')) {
                              setMenuBlocks(prev => prev.filter((_, i) => i !== index));
                            }
                          }}
                        >
                          🗑️
                        </button>
                      </div>
                    </div>

                    <div className="block-content">

                    {
                       ["slider-categoria","slider-transversal"].includes(block.type) ?

                        
                          editingBlock === index ? (
                            renderBlockEditorSlider(block, index)
                          ) : (
                            renderBlockContent(block, index)
                          )

                       :

                       ["slider-agrupado"].includes(block.type) ?
                          editingBlock === index ? (
                            renderBlockEditorSliderAgrupado(block, index)
                          ) : (
                            renderBlockContent(block, index)
                          )                       
                       :
                          editingBlock === index ? (
                            renderBlockEditor(block, index)
                          ) : (
                            renderBlockContent(block, index)
                          )


                    }

                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Panel derecho - Bloques disponibles por categoría */}
        <div className="blocks-panel">
          <div className="blocks-panel-header">
            <h2>Bloques disponibles</h2>
            <span className="blocks-count">{availableBlocks.length} bloques</span>
          </div>
          
          <div className="blocks-categories">
            {Object.entries(blocksByCategory).map(([category, blocks]) => (
              <div key={category} className="category-section">
                <h3 className="category-title">{category}</h3>
                <div className="blocks-grid">
                  {blocks.map(block => (
                    <div
                      key={block.id}
                      className="available-block"
                      draggable
                      onDragStart={(e) => handleDragStart(e, block, true)}
                      onDragEnd={() => setDraggedBlock(null)}
                    >
                      <div className="block-icon">{block.icon}</div>
                      <div className="block-info">
                        <div className="block-title">{block.title}</div>
                        <div className="block-description">{block.description}</div>
                      </div>
                      <span className="block-drag-indicator">⋮⋮</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="blocks-panel-footer">
            <p className="drag-hint">
              <span className="hint-icon">🎯</span>
              Arrastra bloques al área de trabajo
            </p>
          </div>
        </div>
      </div>

      {/* Input file oculto para subir imágenes */}
      <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        style={{ display: 'none' }}
        onChange={(e) => {
          const file = e.target.files[0];
          if (file && uploadingForBlock !== null) {
            const reader = new FileReader();
            reader.onload = (event) => {
              setMenuBlocks(prev => {
                const newBlocks = [...prev];
                if (!newBlocks[uploadingForBlock].data) {
                  newBlocks[uploadingForBlock].data = {};
                }
                newBlocks[uploadingForBlock].data.url = event.target.result;
                return newBlocks;
              });
            };
            reader.readAsDataURL(file);
          }
          setUploadingForBlock(null);
        }}
      />
    </div>
</>

  );
};

export default BlockEditorInformation;